import styled from 'styled-components'
import * as All from '../BaseStyles'

export const DropdownItemDiv = styled(All.Div)`
    height: 5rem;
    width: 100%;
    display: flex;
    border-radius: 1rem;
    transition: background 500ms;
    &:hover {
        background-color: #E8E8E8;
        filter: none;
    }
`

export const DropdownText = styled.p`
    font-size: 1.6rem;
    color: black;
    margin: auto;
`;
